import React, { memo } from 'react';

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Tooltip, useTheme } from '@mui/material';

const fontSize = '12px';

const Dot = React.forwardRef<SVGSVGElement, { color: string }>(
  ({ color, ...props }, ref) => (
    <FiberManualRecordIcon
      ref={ref}
      {...props}
      style={{
        fontSize,
        color,
      }}
    />
  ),
);

function getTooltipTitle(deleted: boolean, loading: boolean, active: boolean) {
  if (deleted) return 'This user has been deleted';
  if (loading) return '';
  if (active) return 'Active — user has activated Control';
  return 'Inactive — user has not activated Control';
}

export const ActiveUserIcon = memo(
  //
  function ActiveUserIcon({
    active = false,
    loading = false,
    deleted = false,
  }: ActiveUserIconProps) {
    const { palette } = useTheme();

    const color = deleted
      ? palette?.grey[600]
      : loading
      ? palette?.grey[500]
      : active
      ? palette?.green[500]
      : palette?.red[500];

    const title = getTooltipTitle(deleted, loading, active);

    if (!title) {
      return <Dot color={color} />;
    }

    return (
      <Tooltip title={title} placement="left-start">
        <Dot color={color} />
      </Tooltip>
    );
  },
);

export interface ActiveUserIconProps {
  readonly active?: boolean;
  readonly loading?: boolean;
  readonly deleted?: boolean;
}
